import { FunctionComponent } from "react";
import React, { useEffect } from "react";
import styles from "./Fixr.module.scss";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import { useAppSelector } from "app/redux.store";
import { useSelector } from "react-redux";
import getButtonStyles from "components/Button/helpers/getButtonStyles";

const Fixr: FunctionComponent<any> = (props) => {
  const wrapperClasses = getWrapperClasses(props.settings);
  const wrapperStyles = useWrapperStyles(props.settings);
  const overlay = useAppSelector((state) => state.overlay);
  const settings = useSelector((state) => state.settings.content);
  const themeButtonStyles = getButtonStyles(settings?.theme, props.variant);

  const attributes = overlay?.content?.fixrAttributesList?.reduce(
    (acc: any, attribute: any) => {
      acc[attribute?.content?.attributeText] = attribute?.content?.value;
      return acc;
    },
    {}
  );

  const hasDarkThemeAttribute =
    Object.keys(attributes).includes("data-fixr-theme") &&
    attributes["data-fixr-theme"] === "dark";
  const hasDarkThemeClass = hasDarkThemeAttribute ? styles.dark : "";

  const loadScript = async (src: string) => {
    const promise = new Promise<void>((resolve, reject) => {
      const scriptElement = document.createElement("script");

      scriptElement.type = "text/javascript";
      scriptElement?.setAttribute(
        "data-fixr-shop-id",
        `${overlay.content?.fixrIdentifier}`
      );
      Object?.entries(attributes).forEach(([key, value]) => {
        scriptElement?.setAttribute(`${key}`, `${value}`);
      });
      scriptElement.async = false;
      scriptElement.onload = () => {
        resolve();
      };

      document.body
        .querySelector(`.${styles.container}`)
        ?.appendChild(scriptElement);
      scriptElement.src = src;
    });
    return promise;
  };

  useEffect(() => {
    loadScript("https://web-cdn.fixr.co/scripts/fixr-shop-widget.v1.min.js");
    return () => {
      const scriptElement = document.querySelector(
        `script[src="https://web-cdn.fixr.co/scripts/fixr-shop-widget.v1.min.js"]`
      );
      if (scriptElement) {
        scriptElement.parentNode?.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <section
      className={combineClasses(
        styles.wrapper,
        hasDarkThemeClass,
        ...wrapperClasses
      )}
      style={{ ...wrapperStyles, ...themeButtonStyles }}
    >
      <div className={styles.container}>
        <h2 className={styles.heading}>{overlay.content?.heading}</h2>
      </div>
    </section>
  );
};

export default Fixr;
